export default __webpack_public_path__ + "static/groupClass-fed33284a73a53582f7c1e1064745cd1.png";